import {
  INVOICE_SYMBOL_ACTIVE,
  INVOICE_SYMBOL_ACTIVE_FAIL,
  INVOICE_SYMBOL_ACTIVE_RESET,
  INVOICE_SYMBOL_ACTIVE_SUCCESS,
  INVOICE_SYMBOL_CREATE,
  INVOICE_SYMBOL_CREATE_FAIL,
  INVOICE_SYMBOL_CREATE_RESET,
  INVOICE_SYMBOL_CREATE_SUCCESS,
  INVOICE_SYMBOL_DELETE,
  INVOICE_SYMBOL_DELETE_FAIL,
  INVOICE_SYMBOL_DELETE_RESET,
  INVOICE_SYMBOL_DELETE_SUCCESS,
  INVOICE_SYMBOL_DETAIL,
  INVOICE_SYMBOL_DETAIL_FAIL,
  INVOICE_SYMBOL_DETAIL_RESET,
  INVOICE_SYMBOL_DETAIL_SUCCESS,
  INVOICE_SYMBOL_LIST,
  INVOICE_SYMBOL_LIST_COLUMN,
  INVOICE_SYMBOL_LIST_FAIL,
  INVOICE_SYMBOL_LIST_RESET,
  INVOICE_SYMBOL_LIST_SUCCESS,
  INVOICE_SYMBOL_UPDATE,
  INVOICE_SYMBOL_UPDATE_FAIL,
  INVOICE_SYMBOL_UPDATE_RESET,
  INVOICE_SYMBOL_UPDATE_SUCCESS,
} from "./actionTypes";

// List Invoice Symbol
export const listInvoiceSymbol = (params = {}, isListManager = false) => ({
  type: INVOICE_SYMBOL_LIST,
  payload: { params },
  isListManager,
});

export const listInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_LIST_SUCCESS,
  payload: data,
});

export const listInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_LIST_FAIL,
  payload: error,
});

export const resetListInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_LIST_RESET,
  payload: {},
});

export const setListInvoiceSymbolColumn = (field, value) => ({
  type: INVOICE_SYMBOL_LIST_COLUMN,
  payload: { field, value },
});

// Create Invoice Symbol
export const createInvoiceSymbol = (data = {}) => ({
  type: INVOICE_SYMBOL_CREATE,
  payload: { data },
});

export const createInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_CREATE_SUCCESS,
  payload: data,
});

export const createInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_CREATE_FAIL,
  payload: error,
});

export const resetCreateInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_CREATE_RESET,
  payload: {},
});

// Detail Invoice Symbol
export const detailInvoiceSymbol = (invoiceSymbolId, params = {}) => ({
  type: INVOICE_SYMBOL_DETAIL,
  payload: { invoiceSymbolId, params },
});

export const detailInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_DETAIL_SUCCESS,
  payload: data,
});

export const detailInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_DETAIL_FAIL,
  payload: error,
});

export const resetDetailInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_DETAIL_RESET,
  payload: {},
});

// Update Invoice Symbol
export const updateInvoiceSymbol = (invoiceSymbolId, data = {}) => ({
  type: INVOICE_SYMBOL_UPDATE,
  payload: { invoiceSymbolId, data },
});

export const updateInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_UPDATE_SUCCESS,
  payload: data,
});

export const updateInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_UPDATE_FAIL,
  payload: error,
});

export const resetUpdateInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_UPDATE_RESET,
  payload: {},
});

// Delete Invoice Symbol
export const deleteInvoiceSymbol = invoiceSymbolId => ({
  type: INVOICE_SYMBOL_DELETE,
  payload: { invoiceSymbolId },
});

export const deleteInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_DELETE_SUCCESS,
  payload: data,
});

export const deleteInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_DELETE_FAIL,
  payload: error,
});

export const resetDeleteInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_DELETE_RESET,
  payload: {},
});

// Active Invoice Symbol
export const activeInvoiceSymbol = (invoiceSymbolId, data = {}) => ({
  type: INVOICE_SYMBOL_ACTIVE,
  payload: { invoiceSymbolId, data },
});

export const activeInvoiceSymbolSuccess = data => ({
  type: INVOICE_SYMBOL_ACTIVE_SUCCESS,
  payload: data,
});

export const activeInvoiceSymbolFail = error => ({
  type: INVOICE_SYMBOL_ACTIVE_FAIL,
  payload: error,
});

export const resetActiveInvoiceSymbol = () => ({
  type: INVOICE_SYMBOL_ACTIVE_RESET,
  payload: {},
});
